import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'
import { UIBreakPointConfig, UIComponentConfig } from 'config/layout'
import SideBar from 'layout/Components/SideBar'
import { useEffect, useRef } from 'react'
import { useToggleSidebar } from 'state/app/hooks'
import theme from 'theme'
import { overlayBreakpointMap } from 'theme/overlay'
import { handleClickElement } from 'utils/clickElement'

const MainSidebar: React.FC<{ config?: UIBreakPointConfig<UIComponentConfig> } & BoxProps> = ({ config, ...props }) => {
  const { isSidebarOpen, closeSidebar } = useToggleSidebar()
  const containerRef = useRef(null)
  const cleanupRef = useRef<() => void>(null)

  useEffect(() => {
    if (isSidebarOpen && typeof window !== 'undefined' && window.innerWidth < overlayBreakpointMap.sidebarOverlay) {
      cleanupRef.current = handleClickElement({
        elementId: 'app-content',
        callback: closeSidebar,
      })
    }

    return () => {
      if (cleanupRef.current) {
        cleanupRef.current()
        cleanupRef.current = null
      }
    }
  }, [isSidebarOpen])

  return (
    <Box
      id="sidebar-container"
      position={['fixed', , 'relative']}
      height={['0px', , '100%']}
      zIndex={[theme.zIndices.foreground, theme.zIndices.foreground, 5]}
      display={[
        config?.mobile?.hidden ? 'none' : 'block',
        ,
        config?.tablet?.hidden ? 'none' : 'block',
        ,
        config?.desktop?.hidden ? 'none' : 'block',
      ]}
      ref={containerRef}
      {...props}
    >
      <SideBar />
    </Box>
  )
}

export default MainSidebar
